import './answers.less';
import React from 'react';
import PropTypes from 'prop-types';
import momentTz from 'moment-timezone';
import moment from 'moment';
import cn from 'classname';
import map from 'lodash/map';
import find from 'lodash/find';

import { enum as timezones } from '../../../../../../enums/timezones';
import avatars from '../../../config/avatars';
import AnswerForms from './answer-form';
import Avatar from '../../shared/avatar';

class Answers extends React.Component {
	componentDidMount() {
		scrollToLast.call(this);
	}

	componentDidUpdate(prevProps, nextState) {
		if (this.props.data.posts.length != prevProps.data.posts.length) {
			scrollToLast.call(this);
		}
	}

	render() {
		let {
			data,
			intl,
			toggleCloseForm,
			submitAnswer,
			answerFormInitialValues,
			can,
			timezone
		} = this.props;

		if (data.status === 'closed' && data['close_message'] && data['close_message'].length
			&& !find(data.posts, p => p.isCloseMessage == true)
		) {
			data.posts.push({
				id: null,
				admin_id: data['closed_admin_id'],
				admin_avatar: data['admin_closed_avatar'],
				admin_name: data['admin_closed_name'],
				admin_email: data['admin_closed_email'],
				text: data['close_message'],
				created_at: data.closed_at,
				isCloseMessage: true
			});
		}
		data.posts = data.posts.map(post => {
			post.created_at = moment(post.created_at, 'DD.MM.YYYY HH:mm', true).isValid() ?
				post.created_at :
				formatForTimezone(post.created_at, 'DD.MM.YYYY HH:mm', timezone);
			return post;
		})
			.sort((i, j) => {
				return moment(i.created_at, 'DD.MM.YYYY HH:mm')
					.diff(moment(j.created_at, 'DD.MM.YYYY HH:mm'), 'seconds');
			});

		return (
			<div className="thread-container">
				<div className="container__content-title">
					<div className="container__content-title-position" />
				</div>

				<div className="ext-support__answers">
					<div ref="wrap" className="ext-support__answers-items">
						{map(data.posts, (post, index) => (
							<div
								className={cn({
									answer: true,
									'not-admin': !post.admin_id,
									admin: !!post.admin_id,
									clearfix: true,
									['is-close-msg']: post.isCloseMessage
								})}
								key={index}
							>
								<Avatar
									className="answer__avatar"
									src={
										!post.isCloseMessage
											?	!post.admin_id
												? avatars.affiliateSmall
												: post.admin_avatar
													? post.admin_avatar
													: avatars.adminSmall
											: post.admin_avatar
												? post.admin_avatar
												: avatars.adminSmall
									} />
								<div className="answer__item">
									<div className="answer__item-head clearfix">
										{!post.isCloseMessage || (post.isCloseMessage && post.admin_id)
											? (<p className="name font-proxima-nova-semibold">
												{post.admin_id ? post.admin_name : data.name }
											</p>)
											: (<p className="name font-proxima-nova-semibold">System</p>)
										}
										{!post.isCloseMessage || (post.isCloseMessage && post.admin_id)
											? (<p className="email">{post.admin_email || data.email}</p>)
											: null
										}
										<p className="date">{post.created_at}</p>
									</div>
									<p className="text">{post.text}</p>
								</div>
							</div>
						))}

						<div className="support__answers_empty" ref="last" />
					</div>
					{ can('answer') && (
						<AnswerForms
							ref="form"
							can={can}
							toggleCloseForm={toggleCloseForm}
							submitAnswer={submitAnswer}
							isClosed={data.status === 'closed'}
							initialValues={answerFormInitialValues}
							enableReinitialize={true}
							intl={intl}
						/>
					)}
				</div>
			</div>
		);
	}
}

function scrollToLast() {
	const $wrap = this.refs['wrap'];
	const $last = this.refs['last'];
	$wrap.scrollTop = $last.offsetTop;
}

const formatForTimezone = (
	timestamp,
	format,
	tz = timezones['Europe/Moscow']
) => momentTz.tz(timestamp, tz).format(format);

Answers.propTypes = {
	data: PropTypes.object,
	intl: PropTypes.func,
	toggleCloseForm: PropTypes.func,
	submitAnswer: PropTypes.func,
	answerFormInitialValues: PropTypes.object,
	can: PropTypes.func,
	timezone: PropTypes.string
};

export default Answers;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/answers.js